function navigation() {

	jQuery(function($) {

		// Mobile menu toggle
		$('.js-menu-toggle').click(function(e) {
			e.preventDefault();
			$('body').toggleClass('site-nav-active');
			$(this).toggleClass('menu-open');
			$('.menu--active').removeClass('menu--active');
		});

		// Mobile nav
		$('#main-menu > li:not(.no-submenu) > a').click(function (e) {
			e.preventDefault();
			$('.menu--active').removeClass('menu--active');
			$(this).siblings('.mega-menu__cont').addClass('menu--active');
		});

		// Mobile back button
		$('.menu-back a').click(function(e) {
			e.preventDefault();
			$('.menu--active').removeClass('menu--active');
		});

		// Mobile footer nav
		$('.menu-item-has-children > a').click(function(e) {
			if (window.matchMedia('(max-width: 1023px)').matches) {
				e.preventDefault();
				$(this).parent().toggleClass('menu--active');
			}
		});

	});

}
